import styled from 'styled-components';
import { mediaQuery, toRem } from '../../styles/functions';

export const SelectContainer = styled.div`
  width: 100%;
  // margin: -10px 0 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const StyledSelect = styled.select`
  background: #FFF;
  width: 100%; 
  padding: 10px;
  border: none;
  border-radius: 4px;
  appearance: none;
  position: relative;
  font-size: 18px;
  color: #000;
`;

export const ExtraText = styled.span`
  color: #24A4C4;
  flex: 1; 
  text-align: right;
  padding-left: 10px;
  padding-right: 10px;
  position: absolute;
  font-weight: 400;
  font-size: 18px;
  right: 0;
//   ${mediaQuery('xxxs')(`	
//   font-size: ${toRem(12)};
// `)}
`;